import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/styles";


const useStyle = makeStyles(
    (theme) => ({
        overlay: {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,0.5)',
            zIndex:3
        }
    })
)

export default function BootstrapLoadingButton(props){

    const classes = useStyle();

    const {isLoading,children,...otherProps} = props;

    return (
        <button {...otherProps} disabled={isLoading} className={`btn position-relative ${props.className ? props.className : 'btn-secondary'}`} >
            {children}

            {
                isLoading && (
                    <div className={classes.overlay}>
                        <CircularProgress size={16} disableShrink />
                    </div>
                )
            }
        </button>
    )
}